<!--
 * @Author: your name
 * @Date: 2021-10-26 09:48:04
 * @LastEditTime: 2021-10-26 09:48:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\Xunzhangshu_Website\xzswebsite\src\components\join.vue
-->
<template>
  <div>
      加入我们
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: ''
    }
  },
  methods: {

  },
  mounted(){

  }
}
</script>

<style scoped lang='less'>

</style>
